import { OurPharmaciesPage as PlatformOurPharmaciesPage } from '@jarvis/platform-ui';

export function OurPharmaciesPage() {
  return <PlatformOurPharmaciesPage stateStorageKey="webopsui:our-pharmacies-grid" />;
}
